export default {
    list: {
        title: "Expeditions",
        name: 'expeditions',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: true,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                name: "Actions",
                buttons: [{
                    text: "Add Expedition",
                    icon: "add",
                    link: '/expeditions/new',
                    color: 'primary'
                }],
            }
        },
        columns: [
            {
                name: "ID",
                elements: [{
                    items: [{
                        name: "id",
                        class: "text-center",
                    }, ],
                }, ]
            },
            {
                name: "Seller",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "seller",
                        elements: [{
                            items: [{
                                    name: "fullName",
                                    class: "font-bold text-gray-700",
                                    icone: "contacts"
                                },
                                // {
                                //     name: "email",
                                //     class: "font-light text-gray-700",
                                //     icone: "email"
                                // }
                            ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Weight (Kg)",
                elements: [{
                    items: [{
                        name: "weight",
                        class: "text-center font-bold",
                    }, ],
                }, ]
            },
            {
                name: "Transport Mode",
                elements: [{
                    items: [{
                        name: "transportMode",
                        class: "text-center font-bold",
                    }, ],
                }, ]
            },
            {
                name: "details",
                model: "expedition",
                title: 'Products'
            },
            {
                name: "CARRIER",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "carrier",
                        elements: [{
                            items: [{
                                    name: "name",
                                    class: "font-bold",
                                    icone: "contacts"
                                },
                                {
                                    name: "phone",
                                    class: "font-light text-gray-700",
                                    icone: "local_phone"
                                }
                            ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Country",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "country",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Expedition Date",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "date",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Reception Date",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "arrivalDate",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Status",
                class: "",
                elements: [{
                    items: [{
                        class: "border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none",
                        name: "status",
                        options: (item) => {
                            switch (item) {
                                case 'expedited':
                                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
                                    break;
                                case 'received':
                                    return "color:rgb(58 217 18); border-color: rgb(58 217 18);"
                                    break;
                                case 'processed':
                                        return  "color:rgb(34, 150, 78); border-color: rgb(34, 150, 78);" 
                                        break;  
                                case 'cancelled':
                                    return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);"
                                    break;
                            }
                        },
                    }],
                }, ]
            },
        ],
        columnsDialog: {
            details: 'details',
            elements: [{
                    class: "",
                    name: "Image",
                    referent: "details",
                    attribut: 'product',
                    items: [{
                        name: "picture",
                    }, ]
                },
                {
                    class: "",
                    name: "sous warehouse",
                    referent: "details",
                    items: [{
                        name: "warehouseParentName",
                    }, ]
                },
                {
                    class: "",
                    name: "Name",
                    referent: "details",
                    attribut: 'product',
                    items: [{
                        name: "name",
                    }, ]
                },
                {
                    class: "",
                    name: "Quantity Sent",
                    referent: "details",
                    attribut: 'quantity',
                    items: [{
                        name: "sent",
                    }, ]
                },
                {
                    class: "",
                    referent: "details",
                    name: "Quantity Received",
                    attribut: 'quantity',
                    items: [{
                        name: "received",
                        name_1: "defective",
                    }, ]
                },
                // {
                //     class: "",
                //     referent: "details",
                //     name: "Quantity defective",
                //     attribut: 'quantity',
                //     items: [{
                //         name: "defective",
                //     }, ]
                // },
            ]
        },
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-end",
            elements: [{
                    icone: "remove_red_eye",
                    color: "success",
                    key: 'read',
                    id: "",
                    role: true,
                    link: '/expeditions/detail',
                    tooltip: "Update",
                },
                {
                    icone: "edit",
                    color: "success",
                    role: true,
                    key: 'update',
                    link: '/expeditions/edit',
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: 'delete',
                    tooltip: "Delete",
                }
            ],
        },
        filters: {
            name: 'expeditions',
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "Id, Carrier name, Carrier phone, Contry ....",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [{
                        label: "Status",
                        key: "status",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Seller",
                        key: "seller",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Country",
                        key: "country",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Transport Mode",
                        key: "transportMode",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Weight",
                        key: "weight",
                        value: null,
                        placeholder: "Weight",
                        type: "number",
                        class: "focus:outline-none py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white",
                    },
                ],
            },
        },
    },
}